import React from "react";
import _ from "lodash";
import styled from "styled-components";

const ImageWrapperDefaultComponent = styled.div``;
const ImageDefaultComponent = styled.img``;
const AgeDefaultComponent = styled.div``;
const ReleaseDateDefaultComponent = styled.div``;

const PDSensor = ({
  product,
  image,
  currentRound,
  rounds,
  showReleaseDate,
  showImage,
  showAge,
  duration_field = "total_duration",
  ImageComponent = ImageDefaultComponent,
  ImageWrapperComponent = ImageWrapperDefaultComponent,
  AgeComponent = AgeDefaultComponent,
  ReleaseDateComponent = ReleaseDateDefaultComponent
}) => {
  const productRounds = Object.keys(product).map(r => Number(r));
  const currentProduct = productRounds.includes(currentRound) ? product[currentRound] : {};
  const round = rounds.find(r => r.number === currentRound);

  let duration = _.get(currentProduct, duration_field, 0);
  if (round && round.number > 1 && duration >= 12) {
    duration += (round.number - 1) * 12;
  }

  let year = parseInt((duration - 1) / 12, 10);
  let quarter = duration - year * 12;

  year += 1;
  quarter = quarter / 3 + 1;
  if (quarter >= 5) {
    quarter -= 4;
    year += 1;
  }

  if (round && year < round.number) {
    year = round.number;
  }

  const releaseDate = `Year ${year} Q${quarter}`;
  const age = currentRound in product ? product[currentRound].age : 0;
  const ageInYears = (age / 12).toFixed(0);

  const releaseDateComponent = (
    <ReleaseDateComponent>{releaseDate}</ReleaseDateComponent>
  );
  const imageWrapperComponent = (
    <ImageWrapperComponent>
      <ImageComponent src={image} alt="PD Sensor" />
    </ImageWrapperComponent>
  );
  const ageComponent = <AgeComponent>Age: {ageInYears} Year</AgeComponent>;

  if (showReleaseDate === true && showImage === false && showAge === false) {
    return releaseDateComponent;
  }

  if (showReleaseDate === false && showImage === true && showAge === false) {
    return imageWrapperComponent;
  }

  if (showReleaseDate === false && showImage === false && showAge === true) {
    return ageComponent;
  }

  return (
    <div>
      {showReleaseDate && releaseDateComponent}
      {showImage && imageWrapperComponent}
      {showAge && ageComponent}
    </div>
  );
};

export default PDSensor;



// WEBPACK FOOTER //
// ./src/components/pd/decisions/PDSensor.js